<template>
  <v-container id="areprots" class="mt-13">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div class="header d-flex flex-column align-center">
      <p class="mb-0">Reno Police Department</p>
      <p class="mb-0">Special Weapons & Tactics Team</p>
      <p class="">Reporting</p>
    </div>
    <hr />
    <div class="black--text">
      <p>
        Fill in the fields and click on search. Then, you can browse the search
        results and view or print each report. In search results, you may send
        all the data to one of the report types. If no criteria are selected,
        all the records will be returned, which may take a few minutes.
      </p>
    </div>

    <!-- Form -->
    <div id="full" class="full-form">
      <v-form id="full_form" ref="formIn">
        <!-- header-info -->
        <v-container>
          <v-row dense no-gutters>
            <v-col cols="12" md="12">
              <!-- viusible only on phones -->
              <div class="hide-if-large d-flex justify-space-around align-start">
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Only Terms Below
                </div>
                <v-switch v-model="sterm.all" label=""></v-switch>
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Any terms Below
                </div>
              </div>
              <!-- visble on everything but phones -->
              <div class="hide-if-small d-flex justify-center align-start">
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Only Terms Below
                </div>
                <v-switch v-model="sterm.all" label=""></v-switch>
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Any terms Below
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                class="mr-4"
                id="search_type"
                v-model="sterm.search_type"
                :items="['Please Choose', 'Training', 'After Action']"
                label="Search Type"
                aria-required="true"
                required
                attach
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                v-if="sterm.search_type == 'After Action'"
                class="mr-4"
                id="risk-box1"
                v-model="sterm.rep_officer"
                :items="lst_aftact_users"
                label="By User"
                aria-required="true"
                attach
              ></v-select>
              <v-select
                v-if="sterm.search_type == 'Training'"
                class="mr-4"
                id="risk-box1"
                v-model="sterm.rep_officer"
                :items="lst_train_users"
                label="By User"
                aria-required="true"
                attach
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <!-- NEW: Start/End Year + Month Selects -->
            <v-col cols="12" md="3" lg="3">
              <v-select
                id="start_year"
                v-model="sterm.start_year"
                :items="lst_years"
                label="Start Year"
                attach
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-select
                id="start_month"
                v-model="sterm.start_month"
                :items="lst_months"
                item-text="text"
                item-value="value"
                label="Start Month"
                attach
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-select
                id="end_year"
                v-model="sterm.end_year"
                :items="lst_years"
                label="End Year"
                attach
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-select
                id="end_month"
                v-model="sterm.end_month"
                :items="lst_months"
                item-text="text"
                item-value="value"
                label="End Month"
                attach
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="location"
                counter="60"
                maxlength="60"
                v-model="sterm.location"
                label="Location"
                ref="location"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="casenum"
                name="casenum"
                maxlength="60"
                counter="60"
                v-model="sterm.case_num"
                label=" Case #/SWAT #"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-select
                id="mission_type"
                v-model="sterm.mission_type"
                :items="['Warrant', 'QRF', 'DVP', 'HRT']"
                label="Mission Type"
                attach
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4" lg="4">
              <v-select
                id="nfdd"
                v-model="sterm.nfdd"
                :items="['n/a', 'Yes', 'No']"
                label="NFDD"
                attach
              ></v-select>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-select
                id="shots_fired"
                v-model="sterm.shots_fired"
                :items="['n/a', 'Yes', 'No']"
                label="Shots Fired"
                attach
              ></v-select>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <!-- Optional: show computed dates for debugging (comment out if you don't want it) -->
              <v-text-field
                :value="frm_date && to_date ? frm_date + ' ~ ' + to_date : ''"
                label="Computed Date Range"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <div class="submit-btn mt-3 d-flex justify-center align-center">
        <v-btn color="primary" dark class="mb-2 mr-3" @click="search"
          >submit</v-btn
        >
        <v-btn color="primary" dark class="mb-2" @click="reset">reset</v-btn>
      </div>
    </div>

    <search_results
      :lst_search_results="lst_results"
      :update_search_results="update_search_results"
      :report_src="sterm.search_type"
    ></search_results>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.header p {
  font-size: 1.2em;
  font-weight: 400;
}
@media (min-width: 0px) {
  .hide-if-large {
    display: none !important;
  }
  .hide-if-small {
    display: flex !important;
  }
}
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const search_results = () => import("../components/search_results.vue");

export default {
  name: "reports",
  mixins: [bus_common],
  components: { search_results },
  props: [],

  data() {
    return {
      update_search_results: null,
      lst_train_users: [],
      lst_aftact_users: [],

      // NEW: year/month select sources
      lst_years: [],
      lst_months: [
        { text: "Jan", value: 1 },
        { text: "Feb", value: 2 },
        { text: "Mar", value: 3 },
        { text: "Apr", value: 4 },
        { text: "May", value: 5 },
        { text: "Jun", value: 6 },
        { text: "Jul", value: 7 },
        { text: "Aug", value: 8 },
        { text: "Sep", value: 9 },
        { text: "Oct", value: 10 },
        { text: "Nov", value: 11 },
        { text: "Dec", value: 12 },
      ],

      sterm_reset: {
        all: true,
        search_type: "After Action",
        rep_officer: "",

        // NEW: default range (overwritten in init)
        start_year: "",
        start_month: "",
        end_year: "",
        end_month: "",

        location: "Cafe",
        case_num: "99-12346",
        mission_type: "Warrant",
        nfdd: "n/a",
        shots_fired: "n/a",
        property_damage: "",
      },

      sterm: {
        all: true,
        search_type: "Please Choose",
        rep_officer: "",

        // NEW
        start_year: "",
        start_month: "",
        end_year: "",
        end_month: "",

        location: "",
        case_num: "",
        mission_type: "",
        nfdd: "n/a",
        shots_fired: "n/a",
      },

      lst_results: [],
    };
  },

  computed: {
    // first day of selected start month
    frm_date() {
      const y = parseInt(this.sterm.start_year, 10);
      const m = parseInt(this.sterm.start_month, 10);
      if (!y || !m) return "";
      return this.toYmd(new Date(y, m - 1, 1));
    },
    // last day of selected end month
    to_date() {
      const y = parseInt(this.sterm.end_year, 10);
      const m = parseInt(this.sterm.end_month, 10);
      if (!y || !m) return "";
      return this.toYmd(new Date(y, m, 0)); // day 0 of next month = last day of current month
    },
  },

  methods: {
    message1() {
      alert("This button does nothing yet.");
    },

    toYmd(dt) {
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const d = String(dt.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },

    initYearList() {
      const nowY = new Date().getFullYear();
      const startY = 2000; // adjust to taste
      const endY = nowY + 1;

      this.lst_years = [];
      for (let y = endY; y >= startY; y--) {
        this.lst_years.push(String(y));
      }
    },

    update_search_res() {
      this.update_search_results = new Date();
    },

    search() {
      console.log("search");
      this.lst_results = [];
      console.log("lst results: " + this.lst_results.length);
      this.update_search_res();
      this.show_loader(true);

      //validate Search Type
      if (this.sterm.search_type == "Please Choose" || this.sterm.search_type == "") {
        this.swall_it("Search Status", "Please select a Search Type.", "warning", null, null);
        return true;
      }

      //validate date selects
      if (!this.frm_date || !this.to_date) {
        this.swall_it("Search Status", "Please select Start/End Year and Month.", "warning", null, null);
        return true;
      }

      //validate order
      if (new Date(this.frm_date) > new Date(this.to_date)) {
        this.swall_it("Search Status", "Start date must be before (or equal to) end date.", "warning", null, null);
        return true;
      }

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.sterm = this.mno(this.sterm);

      // NEW: computed literal dates
      formIn.sterm.frm_date = this.frm_date;
      formIn.sterm.to_date = this.to_date;

      formIn.apiname = "search";
      this.$store.commit("setSterm", formIn);

      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("d length: " + data.length);
          if (data.length == 0) {
            this.swall_it(
              "Search Status",
              "Unfortunately, your search didn't find any results. Please change your criteria and try again.",
              "warning",
              null,
              null
            );
          } else {
            self.lst_results = self.mno(data);
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    research() {
      //retrive and use the old sterm
      this.strem = this.mno(this.$store.state.sterm);
      let self = this;
      this.search(function () {
        //empty store copy of sterm if any
        let empt = {};
        self.$store.commit("setSterm", empt);
      });
    },

    reset() {
      this.sterm = this.mno(this.sterm_reset);

      // Ensure defaults exist after reset
      if (!this.sterm.start_year || !this.sterm.start_month || !this.sterm.end_year || !this.sterm.end_month) {
        const now = new Date();
        const y = now.getFullYear();
        const m = now.getMonth() + 1;
        this.sterm.start_year = String(y);
        this.sterm.start_month = m;
        this.sterm.end_year = String(y);
        this.sterm.end_month = m;
      }
    },

    get_users_aftact_rep() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_users_aftact_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_aftact_users = self.mno(data);
          self.lst_aftact_users.unshift("n/a");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_users_aftact_rep", msg, "error", null, null);
        });
    },

    get_users_train_rep() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_users_train_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_train_users = self.mno(data);
          self.lst_train_users.unshift("n/a");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_train_users", msg, "error", null, null);
        });
    },

    highlight_link() {
      let lstlinks = document.querySelectorAll(".menulink");
      console.log("lengths: " + lstlinks.length);
      for (let index = 0; index < lstlinks.length; index++) {
        const element = lstlinks[index];
        element.style.color = "white";
      }
      document.getElementById("reportslink").style.color = "orange";
    },

    init() {
      this.get_users_train_rep();
      this.get_users_aftact_rep();

      // NEW: set up year list + default month/year
      this.initYearList();
      const now = new Date();
      const y = now.getFullYear();
      const m = now.getMonth() + 1;

      // Default: current month to current month
      this.sterm.start_year = String(y);
      this.sterm.start_month = m;
      this.sterm.end_year = String(y);
      this.sterm.end_month = m;

      // Keep reset aligned so Reset returns to something sane
      this.sterm_reset.start_year = String(y);
      this.sterm_reset.start_month = m;
      this.sterm_reset.end_year = String(y);
      this.sterm_reset.end_month = m;
    },
  },

  activated() {
    console.log("aftact Component is activated again!");
    this.highlight_link();
  },

  mounted() {
    this.$nextTick(() => {
      this.highlight_link();
      this.init();
    });
  },
};
</script>
